var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count == 0)?_c('span',[_vm._v(" "+_vm._s(_vm.$t("cart.noCartElements"))+" ")]):(_vm.count == 1)?_c('span',[_vm._v(" Hai "),_c('b',[_vm._v("1 prodotto")]),_vm._v(" nel carrello ")]):_c('span',[_vm._v(" Hai "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.count)+" prodotti")]),_vm._v(" nel carrello ")])
}
var staticRenderFns = []

export { render, staticRenderFns }